import React from 'react';
import {ExclamationMark} from '../ExclamationMark';

export type ErrorBannerProps = {
	text?: string | null;
	className?: string;
};

export function ErrorBanner({text, className}: ErrorBannerProps): React.ReactElement {
	return (
		<div
			className={['mb-7 flex items-center gap-4 bg-white p-2', className].filter(Boolean).join(' ')}
			role="alert"
			aria-live="polite"
		>
			<ExclamationMark />
			<span className="text-normal leading-snug text-black">{text || 'Что-то не так'}</span>
		</div>
	);
}
